// extracted by mini-css-extract-plugin
export default {"mn-drawer":"index_mn-drawer__JSlG9"};